/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { TeamMemberRef } from "./TeamMemberRef";
import {
  TeamMemberRefFromJSON,
  TeamMemberRefFromJSONTyped,
  TeamMemberRefToJSON,
  TeamMemberRefToJSONTyped,
} from "./TeamMemberRef";

/**
 *
 * @export
 * @interface TeamDetail
 */
export interface TeamDetail {
  /**
   *
   * @type {string}
   * @memberof TeamDetail
   */
  teamId: string;
  /**
   *
   * @type {string}
   * @memberof TeamDetail
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof TeamDetail
   */
  description?: string | null;
  /**
   *
   * @type {Array<TeamMemberRef>}
   * @memberof TeamDetail
   */
  members: Array<TeamMemberRef>;
}

/**
 * Check if a given object implements the TeamDetail interface.
 */
export function instanceOfTeamDetail(value: object): value is TeamDetail {
  if (!("teamId" in value) || value["teamId"] === undefined) return false;
  if (!("name" in value) || value["name"] === undefined) return false;
  if (!("members" in value) || value["members"] === undefined) return false;
  return true;
}

export function TeamDetailFromJSON(json: any): TeamDetail {
  return TeamDetailFromJSONTyped(json, false);
}

export function TeamDetailFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): TeamDetail {
  if (json == null) {
    return json;
  }
  return {
    teamId: json["teamId"],
    name: json["name"],
    description: json["description"] == null ? undefined : json["description"],
    members: (json["members"] as Array<any>).map(TeamMemberRefFromJSON),
  };
}

export function TeamDetailToJSON(json: any): TeamDetail {
  return TeamDetailToJSONTyped(json, false);
}

export function TeamDetailToJSONTyped(
  value?: TeamDetail | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    teamId: value["teamId"],
    name: value["name"],
    description: value["description"],
    members: (value["members"] as Array<any>).map(TeamMemberRefToJSON),
  };
}
